import { useLazyQuery } from "@vue/apollo-composable";
import { GetPageDocument } from "@/core/api/graphql/types";
import type { GetPageQueryVariables, Query } from "@/core/api/graphql/types";
import type { MaybeRefOrGetter } from "vue";
import { graphqlClient } from "../../../client";

export function useGetPage(payload: MaybeRefOrGetter<GetPageQueryVariables>) {
  return useLazyQuery(GetPageDocument, payload, { fetchPolicy: "cache-and-network" });
}

// Innovadis custom
export async function useGetBrandPage(payload: GetPageQueryVariables) {
  const { data } = await graphqlClient.query<Required<Pick<Query, "page">>, GetPageQueryVariables>({
    query: GetPageDocument,
    variables: {
      ...payload,
    },
  });

  return data.page;
}
